import { useMemo } from "react";
import {
  useCanViewBeneficiariesBool,
  useCanViewGrpCommissionBool,
  useCanViewGrpEnrollmentsBool
} from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import type { Path } from "@/router";
import { GRP_PERSON_PROFILE_FLAG } from "./grp/constants";

export function useShowCommissionPersonGrpTab(): boolean {
  const flags = useFlags();
  const canViewGrpCommission = useCanViewGrpCommissionBool();

  return !!flags["commission-grp-platform"] && canViewGrpCommission;
}

export function useShowRetirementPersonGrpTab(): boolean {
  const flags = useFlags();
  const canViewGrpEnrollments = useCanViewGrpEnrollmentsBool();

  return !!flags[GRP_PERSON_PROFILE_FLAG] && canViewGrpEnrollments;
}

export function useShowPersonGrpBenefitsTab(): boolean {
  const showCommissionGrp = useShowCommissionPersonGrpTab();
  const showRetirementGrp = useShowRetirementPersonGrpTab();

  return showCommissionGrp || showRetirementGrp;
}

export function useCanAccessPersonBenefits(): boolean {
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  return canViewBeneficiaries || showGrpTab;
}

export function usePersonBenefitsDefaultTab(pgaId: string): Path {
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  return useMemo(() => {
    if (canViewBeneficiaries) {
      return `/people/${pgaId}/benefits/beneficiaries` as Path;
    }

    if (showGrpTab) {
      return `/people/${pgaId}/benefits/grp` as Path;
    }

    return `/people/${pgaId}/benefits/beneficiaries` as Path;
  }, [canViewBeneficiaries, pgaId, showGrpTab]);
}
